import plugin from './plugin'
import software from './software'
import constraint from './constraint'
import scriptVersion from './scriptVersion'
import activityList from './activityList'
import activityDetail from './activityDetail'
import error from './error'
import dataDictionary from './dataDictionary'
import storageMount from './storageMount'
import platform from './platform'
import calendar from './calendar'
import administratorNotice from './administratorNotice'
import nodeNotice from './nodeNotice'
import clientPromotionNotification from './clientPromotionNotification'
import clientSystemNotification from './clientSystemNotification'
import exchangeRates from './exchangeRates'
import marketingActivities from './marketingActivities'
import prizePool from './prizePool'
import scheduleConfig from './scheduleConfig'
import softwareCharge from './softwareCharge'
import additionalCharges from './additionalCharges'
import clientAd from './clientAd'
import miniProgramAd from './miniProgramAd'
import overviewAd from './overviewAd'
import cgtalks from './cgtalks'
import background from './background'
import clientSlideshow from './clientSlideshow'
import jsonTemplateConfig from './jsonTemplateConfig'
import dependency from './dependency'

export default {
  namespaced: true,
  modules: {
    software,
    plugin,
    constraint,
    scriptVersion,
    activityList,
    activityDetail,
    error,
    dataDictionary,
    storageMount,
    platform,
    calendar,
    administratorNotice,
    nodeNotice,
    clientPromotionNotification,
    exchangeRates,
    clientSystemNotification,
    marketingActivities,
    prizePool,
    scheduleConfig,
    softwareCharge,
    additionalCharges,
    clientAd,
    miniProgramAd,
    overviewAd,
    cgtalks,
    background,
    clientSlideshow,
    jsonTemplateConfig,
    dependency,
  },
}
